<template>
  <vs-popup
    class="holamundo advance-session-settings"
    title="Sessions - Advanced Settings"
    :active.sync="popupActive2"
  >
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <label for>Video Stream Qualty (Default)</label>
        <v-select
          v-model="settingsData.VideoStreamProfile"
          class="w-full select-large"
          :options="VideoStreamProfiles"
        />

        <div class="session-option-upload-area">
          <div class="popup-single-upload">
            <p>Live Stage Logo (2:1 ratio)</p>
            <span class="option-right-area">
              <img
                v-show="LiveStageLogosrc"
                :src="LiveStageLogosrc"
                class="mr-8 rounded h-10 w-10"
              />
              <div
                class="popup-single-upload-right"
                style="display: inline-flex"
              >
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                  <div class="popup-info-tooltips">
                    <img
                      src="../../assets/images/Live-stage-logo.jpg"
                      alt="Display"
                    />
                  </div>
                </div>
                <vs-button color="primary" type="filled" class="upload-btn"
                  >Upload</vs-button
                >
                <input
                  type="file"
                  accept="image/*"
                  class="d-block upload-main-btn"
                  @change="
                    update_avatar(
                      $event,
                      '200x100',
                      'LiveStageLogoFile',
                      'LiveStageLogosrc',
                      true
                    )
                  "
                />
              </div>
            </span>
          </div>

          <div class="popup-single-upload">
            <p>Live Stage Logo Hyperlink</p>
            <vs-input
              class="w-full"
              v-model="settingsData.LiveStageLogoHyperlink"
            />
          </div>

          <div class="popup-single-upload">
            <p>Live Stage Timer Background (2732px x 2048px)</p>
            <span class="option-right-area">
              <img
                v-show="LiveStageBackgroundPotraitsrc"
                :src="LiveStageBackgroundPotraitsrc"
                class="mr-8 rounded h-10 w-10"
              />
              <div
                class="popup-single-upload-right"
                style="display: inline-flex"
              >
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                  <div class="popup-info-tooltips">
                    <img
                      src="../../assets/images/timmer-tooltip-background.jpg"
                      alt="Display"
                    />
                  </div>
                </div>
                <vs-button color="primary" type="filled" class="upload-btn"
                  >Upload</vs-button
                >
                <input
                  type="file"
                  accept="image/*"
                  class="d-block upload-main-btn"
                  @change="
                    update_avatar(
                      $event,
                      '2732x2048',
                      'LiveStageBackgroundPotraitFile',
                      'LiveStageBackgroundPotraitsrc'
                    )
                  "
                />
              </div>
            </span>
          </div>

          <div class="popup-single-upload">
            <p>Live Stage Timer Background (2048px x 2732px)</p>
            <span class="option-right-area">
              <img
                v-show="LiveStageBackgroundLandscapesrc"
                :src="LiveStageBackgroundLandscapesrc"
                class="mr-8 rounded h-10 w-10"
              />
              <div
                class="popup-single-upload-right"
                style="display: inline-flex"
              >
                <div class="info-option-wrapper">
                  <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                  <div class="popup-info-tooltips">
                    <img
                      src="../../assets/images/timmer-tooltip-background.jpg"
                      alt="Display"
                    />
                  </div>
                </div>
                <vs-button color="primary" type="filled" class="upload-btn"
                  >Upload</vs-button
                >
                <input
                  type="file"
                  accept="image/*"
                  class="upload-main-btn"
                  @change="
                    update_avatar(
                      $event,
                      '2048x2732',
                      'LiveStageBackgroundLandscapeFile',
                      'LiveStageBackgroundLandscapesrc'
                    )
                  "
                />
              </div>
            </span>
          </div>

          <!--<div class="popup-single-upload">
                        <p>Enable Session Rating</p>
                        <vs-switch v-model="settingsData.EnableSessionRating" />
                      </div>-->
          <div class="popup-single-upload">
            <p>Start Live Stage In Maximized Mode</p>
            <div class="popup-single-upload-right">
              <div class="info-option-wrapper">
                <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                <div class="popup-info-tooltips info-top-custom-tooltip">
                  <img
                    src="../../assets/images/maximize-mode.jpg"
                    alt="Display"
                  />
                </div>
              </div>
              <vs-switch v-model="settingsData.StartLiveStageInMaximizedMode" />
            </div>
          </div>
          <div class="popup-single-upload">
            <p>Display Maximize Button</p>
            <div class="popup-single-upload-right">
              <div class="info-option-wrapper">
                <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                <div class="popup-info-tooltips info-top-custom-tooltip">
                  <img
                    src="../../assets/images/maximize-button.jpg"
                    alt="Display"
                  />
                </div>
              </div>
              <vs-switch v-model="settingsData.DisplayMaximizeButton" />
            </div>
          </div>
          <div class="popup-single-upload">
            <p>Show Session Panel</p>
            <div class="popup-single-upload-right">
              <div class="info-option-wrapper">
                <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                <div class="popup-info-tooltips info-top-custom-tooltip">
                  <img
                    src="../../assets/images/maximize-button.jpg"
                    alt="Display"
                  />
                </div>
              </div>
              <vs-switch v-model="settingsData.ShowSessions" />
            </div>
          </div>
          <div class="popup-single-upload">
            <p>Show Session Player Right Panel</p>
            <div class="popup-single-upload-right">
              <!-- <div class="info-option-wrapper">
                <feather-icon class="" icon="InfoIcon" title="Info Icon" />
                <div class="popup-info-tooltips info-top-custom-tooltip">
                  <img
                    src="../../assets/images/maximize-button.jpg"
                    alt="Display"
                  />
                </div>
              </div> -->
              <vs-switch v-model="settingsData.ShowPlayerRightPanel" />
            </div>
          </div>
          <div class="popup-single-upload">
            <p>Play Button Text</p>
            <vs-input class="w-full" v-model="settingsData.PlayButtonText" />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="popup-single-upload">
          <p>Display Session Timer</p>
          <div class="popup-single-upload-right">
            <div class="info-option-wrapper">
              <feather-icon class="" icon="InfoIcon" title="Info Icon" />
              <div class="popup-info-tooltips">
                <img
                  src="../../assets/images/session-timmer.jpg"
                  alt="Display"
                />
              </div>
            </div>
            <vs-switch v-model="settingsData.DisplaySessionTimer" />
          </div>
        </div>
        <div class="popup-single-upload">
          <p>Display Audience Counter</p>
          <div class="popup-single-upload-right">
            <div class="info-option-wrapper">
              <feather-icon class="" icon="InfoIcon" title="Info Icon" />
              <div class="popup-info-tooltips">
                <img
                  src="../../assets/images/audience-counter.jpg"
                  alt="Audience Counter"
                />
              </div>
            </div>
            <vs-switch v-model="settingsData.DisplayAudienceCounter" />
          </div>
        </div>
        <div class="popup-single-upload">
          <p>Display Company &amp; Title In Video Tile</p>
          <div class="popup-single-upload-right">
            <div class="info-option-wrapper">
              <feather-icon class="" icon="InfoIcon" title="Info Icon" />
              <div class="popup-info-tooltips">
                <img
                  src="../../assets/images/company-title.jpg"
                  alt="Company Title"
                />
              </div>
            </div>
            <vs-switch
              v-model="settingsData.DisplayCompanyAndTitleInVideoTile"
            />
          </div>
        </div>
        <div class="popup-single-upload">
          <p>Auto Start Recording</p>
          <div class="popup-single-upload-right">
            <vs-switch v-model="settingsData.AutoStartRecording" />
          </div>
        </div>
        <div class="popup-single-upload">
          <p>Display Agenda Type</p>
          <!-- <v-select class="track-select" label="Name" v-model="settingsData.AgendaFilterOption" :options="AgendaFilterOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
          <vs-radio
            v-model="settingsData.AgendaFilterOption"
            vs-name="AgendaFilterOption"
            vs-value="0"
            >Full Agenda</vs-radio
          >
          <vs-radio
            v-model="settingsData.AgendaFilterOption"
            vs-name="AgendaFilterOption"
            vs-value="1"
            >My Agenda</vs-radio
          >
          <vs-radio
            v-model="settingsData.AgendaFilterOption"
            vs-name="AgendaFilterOption"
            vs-value="2"
            >Both</vs-radio
          >
        </div>
        <div class="popup-single-upload">
          <p>Choose Session View</p>
          <!-- <v-select class="track-select" label="Name" v-model="settingsData.AgendaFilterOption" :options="AgendaFilterOptions" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->
          <vs-radio
            v-model="settingsData.SessionView"
            vs-name="SessionView"
            vs-value="Default"
            >Default</vs-radio
          >
          <vs-radio
            v-model="settingsData.SessionView"
            vs-name="SessionView"
            vs-value="Calender"
            >Calender View</vs-radio
          >
        </div>
        <div
          class="popup-single-upload"
          v-show="settingsData.AgendaFilterOption == 2"
        >
          <p>Allow Add-Remove MyAgenda</p>
          <div class="popup-single-upload-right">
            <div class="info-option-wrapper">
              <feather-icon class="" icon="InfoIcon" title="Info Icon" />
              <div class="popup-info-tooltips">
                <img
                  src="../../assets/images/add-remove-agenda.jpg"
                  alt="Add Remove Agenda"
                />
              </div>
            </div>
            <vs-switch v-model="settingsData.AllowAddRemoveMyAgenda" />
          </div>
        </div>

        <div class="popup-single-upload livestage-closing-msg">
          <p>Live Stage Closing Message</p>
          <quill-editor
            class="w-full"
            v-model="settingsData.LiveStageEndMessage"
          />
        </div>
      </div>
    </div>
    <!--<label for>Enable MyAgenda</label>
          <vs-switch v-model="settingsData.IsMyAgendaEnabled" />-->

    <br />
    <div align="right">
      <vs-button color="rgb(76, 139, 246)" type="filled" class="sub-btn" v-on:click="saveSettings"
        >Save</vs-button
      >
    </div>
  </vs-popup>
</template>
<script>
import moduleSessionManagement from "@/store/session-management/moduleSessionManagement.js";
import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
var vm;
export default {
  components: {
      quillEditor,
       vSelect,
  },
  props: {
    data: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      settingsData: {
        IsMyAgendaEnabled: false,
        VideoStreamProfile: { label: "High", value: "480p_1" },
        EnableSessionRating: false,
        LiveStageLogo: null,
        LiveStageBackground: null,
        LiveStageBackgroundLandscape: null,
        AgendaFilterOption: 0,
        AllowAddRemoveMyAgenda: false,
        SessionView : 'Default'
      },
      IsDefaultSettings: false,
      popupActive2: this.data,
      LiveStageBackgroundPotraitsrc: null,
      LiveStageBackgroundLandscapesrc: null,
      LiveStageLogosrc: null,
      LiveStageBackgroundPotraitFile: null,
      LiveStageBackgroundLandscapeFile :null,
      LiveStageLogoFile : null,
            VideoStreamProfiles: [
        { label: "High", value: "480p_1" },
        { label: "Medium", value: "360p_1" },
        { label: "Low", value: "240p_1" },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    getDefaultSettings() {
      this.IsDefaultSettings = true;
      this.settingsData = {
        ActiveSpeakerFocus: false,
        ActiveSpeakerMinVolume: 0,
        ActiveSpeakerSorting: false,
        AgendaFilterOption: 0,
        AllowAddRemoveMyAgenda: true,
        AutoStartRecording: true,
        DebugMode: false,
        DisplayAudienceCounter: true,
        DisplayCompanyAndTitleInVideoTile: true,
        DisplayMaximizeButton: true,
        DisplaySessionTimer: true,
        EnableSessionRating: false,
        IsMyAgendaEnabled: false,
        LiveStageBackgroundLandscape: null,
        LiveStageBackgroundPotrait: null,
        LiveStageEndMessage:
          '<p>No more Active Sessions in Live Stage.</p><p><a href="/sessions" rel="noopener noreferrer" target="_blank">Click Here</a> to View All Sessions and On-demand videos!</p>',
        LiveStageLogo: null,
        LiveStageLogoHyperlink: "https://e2m.live/",
        PlayButtonText: null,
        ShowSessions: true,
        ShowPlayerRightPanel: true,
        StartLiveStageInMaximizedMode: false,
        VideoStreamProfile: { label: "High", value: "480p_1" },
        SessionView: 'Default'
      };
      this.LiveStageBackgroundPotraitsrc = null;
      this.LiveStageBackgroundLandscapesrc = null;
      this.LiveStageLogosrc = null;
      this.LiveStageBackgroundPotraitFile = null;
      this.LiveStageBackgroundLandscapeFile = null;
      this.LiveStageLogoFile = null;
      this.popupActive2 = true;
    },
    getSettings() {
      this.$vs.loading();
      this.IsDefaultSettings = false;
      this.$store.dispatch("sessionManagement/getSettings").then((res) => {
        this.settingsData = res;
        this.settingsData.EnableSessionRating = res.EnableSessionRating
          ? res.EnableSessionRating
          : false;
        (this.settingsData.LiveStageLogoHyperlink = res.LiveStageLogoHyperlink
          ? res.LiveStageLogoHyperlink
          : "https://e2m.live/"),
          (this.settingsData.StartLiveStageInMaximizedMode =
            res.StartLiveStageInMaximizedMode != undefined
              ? res.StartLiveStageInMaximizedMode
              : false);
        this.settingsData.DisplayMaximizeButton =
          res.DisplayMaximizeButton != undefined
            ? res.DisplayMaximizeButton
            : true;
        this.settingsData.ShowSessions = res.ShowSessions != undefined ? res.ShowSessions : true;
        this.settingsData.ShowPlayerRightPanel = res.ShowPlayerRightPanel != undefined ? res.ShowPlayerRightPanel : true;
        this.settingsData.PlayButtonText =
          res.PlayButtonText != undefined ? res.PlayButtonText : null;
        this.settingsData.DisplaySessionTimer =
          res.DisplaySessionTimer != undefined ? res.DisplaySessionTimer : true;
        this.settingsData.DisplayAudienceCounter =
          res.DisplayAudienceCounter != undefined
            ? res.DisplayAudienceCounter
            : true;
        this.settingsData.DisplayCompanyAndTitleInVideoTile =
          res.DisplayCompanyAndTitleInVideoTile != undefined
            ? res.DisplayCompanyAndTitleInVideoTile
            : true;
        this.settingsData.AutoStartRecording =
          res.AutoStartRecording != undefined ? res.AutoStartRecording : true;
        this.settingsData.AllowAddRemoveMyAgenda = res.AllowAddRemoveMyAgenda
          ? res.AllowAddRemoveMyAgenda
          : false;
        (this.settingsData.AgendaFilterOption = this.settingsData
          .AgendaFilterOption
          ? this.settingsData.AgendaFilterOption
          : 0),
          (this.settingsData.LiveStageEndMessage = res.LiveStageEndMessage
            ? res.LiveStageEndMessage
            : "No more Active Sessions in Live Stage.</br><a href='/sessions'>Click Here</a> to View All Sessions and On-demand videos!");
        this.LiveStageBackgroundPotraitsrc = res.LiveStageBackgroundPotrait
          ? res.LiveStageBackgroundPotrait
          : null;
        this.LiveStageBackgroundLandscapesrc = res.LiveStageBackgroundLandscape
          ? res.LiveStageBackgroundLandscape
          : null;
        this.LiveStageLogosrc = res.LiveStageLogo ? res.LiveStageLogo : null;
        this.LiveStageBackgroundPotraitFile = null;
        this.LiveStageBackgroundLandscapeFile = null;
        this.LiveStageLogoFile = null;
        this.settingsData.SessionView = this.settingsData.SessionView ? this.settingsData.SessionView : 'Default';
        console.log("1=======",this.settingsData);
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    saveSettings() {
      this.$vs.loading();
      this.settingsData.AgendaFilterOption = Number(
        this.settingsData.AgendaFilterOption
      );
      this.settingsData.AllowAddRemoveMyAgenda =
        this.settingsData.AgendaFilterOption == 2
          ? this.settingsData.AllowAddRemoveMyAgenda
          : false;
      this.settingsData.SessionView = this.settingsData.SessionView ? this.settingsData.SessionView : 'Default';    
      this.$store
        .dispatch("sessionManagement/saveSettings", {
          settingsData: this.settingsData,
          LiveStageBackgroundPotraitFile: this.LiveStageBackgroundPotraitFile,
          LiveStageBackgroundLandscapeFile: this
            .LiveStageBackgroundLandscapeFile,
          LiveStageLogoFile: this.LiveStageLogoFile,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$emit('saveSessionSettingsData')
          this.$vs.loading.close();
        });
    },

    update_avatar(input, fileDimension, fieldName, srcName, checkRatio = false) {
      // You can update avatar Here
      if (input.target.files && input.target.files[0]) {
        const file = input.target.files[0];
        const metadata = {
          contentType: file.type,
        };

        const validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileDimension.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if(checkRatio && this.width == this.height * 2){
            vm[fieldName] = file;
            const reader = new FileReader();
            reader.onload = (e) => {
              vm[srcName] = e.target.result;
            };
            reader.readAsDataURL(input.target.files[0]);
          }
          else if (this.width == dimension[0] && this.height == dimension[1]) {
            vm[fieldName] = file;
            const reader = new FileReader();
            reader.onload = (e) => {
              vm[srcName] = e.target.result;
            };
            reader.readAsDataURL(input.target.files[0]);
          } else {
            let diension = checkRatio ? '2:1' : fileDimension
            alert("File dimension does not match " + diension);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
  },
  mounted() {},
  created() {
    vm = this;
    if (!moduleSessionManagement.isRegistered) {
      this.$store.registerModule("sessionManagement", moduleSessionManagement);
      moduleSessionManagement.isRegistered = true;
    }

    this.$store.dispatch("sessionManagement/getSettings").then((res) => {
      this.settingsData = res;
      this.getSettings();
      console.log("set=======",this.settingsData)
      if(this.settingsData.AgendaFilterOption == null){
          this.getDefaultSettings();
      }
      if(this.settingsData.SessionView == null){
        this.settingsData.SessionView = 'Default';
      }
    });
  },
};
</script>